//
//
//
import drApplyBase from '../drApplyBase';
export default {
  name: 'drApply',
  components: {
    drApplyBase: drApplyBase
  }
};